import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import useGetHistory from "../../../CustomHooks/useAxios/useGetHistory";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { setError } from "../../../redux/dataSlice";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import { endDate, getDateBefore } from "../../../helpers/dateHelpers";
import { DateFilters } from "../../../components/Filter/dateFilters/DateFilters";
import FilterData from "../../../components/Filter/FilterData";
import {
  idleCylindersFilterOptions,
  IDLE_CYLINDERS_SEARCH_OPTIONS,
} from "../utils/cylinderFilter.config";
import { IdleCylindersList } from "../components/IdleCylindersList";
import { DATE_FILTERS_M } from "../../../utils/dateFilters";
import xlxs from "../../../assets/icons/xlsIcon.svg";
import { IDLE_CYLINDERS } from "../apiEndpoints";
import SearchTable from "../../../components/common/SearchTable";
// import { idleCylindersExcelFormatters } from "../utils/idleCylindersExcelFormatters";

export const IdleCylindersPage = () => {
  const [dateRange, setDateRange] = useState({
    start: "",
    end: "",
    currentSelector: "lastMonth",
  });
  const fromDate = getDateBefore(30);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.data);
  const originalData = useSelector((state) => state.data.copyData);
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const dataLength =
    !historyLoaded && !historyErrMsg && isSucceed ? data.length : 0;
  const checkedOriginalData =
    !historyLoaded && !historyErrMsg && isSucceed ? originalData : [];

//   const handleExport = async () => {
//     try {
//         await idleCylindersExcelFormatters(checkedOriginalData);
//     } catch (error) {
//       alert("Failed to generate Excel report");
//     }
//   };

  useEffect(() => {
    getHistory(`${IDLE_CYLINDERS}/${fromDate}/${endDate}`);
  }, []);

  return (
    <MainPageLayout
      headerConfig={{ title: "Idle Cylinders" }}
      numberOfData={dataLength}
      bgColor="bg-[#f0f2f7]"
    >
      <DateFilters
        dateRange={dateRange}
        setDateRange={setDateRange}
        getHistory={getHistory}
        baseUrl={IDLE_CYLINDERS}
        loaded={historyLoaded}
        customeDateFilters={DATE_FILTERS_M}
      />
      {historyLoaded ? (
        <LoadingDisplay height="h-[80vh] mt-2" />
      ) : (
        isSucceed && (
          <>
            <div className="flex justify-between pt-2">
              <div className="flex">
                <SearchTable
                  searchCategories={IDLE_CYLINDERS_SEARCH_OPTIONS}
                />
                <FilterData categories={idleCylindersFilterOptions} />
              </div>
              {/* <div className="flex">
                <button
                  onClick={handleExport}
                  className="ml-1 text-sm flex gap-1 items-center justify-between border-1 py-1 bg-[#00800014] transition-all hover:bg-emerald-50 text-emerald-700 border-emerald-600 rounded-md px-3 font-figtreeMedium"
                >
                  <img src={xlxs} alt="xls" className="w-4 h-4" />
                  Download
                </button>
              </div> */}
            </div>
            <IdleCylindersList />
          </>
        )
      )}
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </MainPageLayout>
  );
};
